
import CheckoutContainer from "@/components/checkout/CheckoutContainer";

const Checkout = () => {
  return <CheckoutContainer />;
};

export default Checkout;
